module.exports = __webpack_public_path__ + "img/in-case-of--emergency@1x.9a2ae39e.png";